import type { CommandDeckWitnessFeedModel } from '../contracts/types'
import { CommandDeckStatusPill } from './CommandDeckStatusPill'

interface Props {
  witnessFeed: CommandDeckWitnessFeedModel
}

function severityClass(severity: string): string {
  return `cd-mc-witness__severity cd-mc-witness__severity--${severity}`
}

export function CommandDeckActivityRail({ witnessFeed }: Props) {
  const { events, emptyState, spanLabel } = witnessFeed

  return (
    <aside
      className="cd-mc-activity cd-mc-activity--witness-rail command-deck-glass"
      aria-labelledby="cd-mc-witness-heading"
    >
      <div className="cd-mc-witness">
      <header className="cd-mc-witness__header">
        <h2 id="cd-mc-witness-heading">Witness</h2>
        <p className="cd-mc-witness__session-label">
          <CommandDeckStatusPill label="CURRENT" variant="current" className="cd-mc-witness__session-pill" />
          <span>Current session</span>
        </p>
        <p className="cd-mc-witness__span-label">{spanLabel}</p>
      </header>

      <div
        className="cd-mc-witness__scroll cd-mc-witness__scroll--bounded"
        role="region"
        aria-label="Operational witness chronicle"
        tabIndex={0}
      >
        {events.length > 0 ? (
          <ol className="cd-mc-witness__list">
            {events.map((event) => (
              <li key={event.id} className="cd-mc-witness__row">
                <div className="cd-mc-witness__meta">
                  <span className="cd-mc-witness__time">{event.timestampLabel}</span>
                  <span className={severityClass(event.severity)}>{event.severity}</span>
                  <span className="cd-mc-witness__confidence">{event.confidence}</span>
                </div>
                <div className="cd-mc-witness__body">
                  <span className="cd-mc-witness__category">{event.category}</span>
                  <strong className="cd-mc-witness__title">{event.title}</strong>
                  {event.summary ? <p className="cd-mc-witness__summary">{event.summary}</p> : null}
                </div>
              </li>
            ))}
          </ol>
        ) : emptyState ? (
          <div className="cd-mc-witness__empty">
            <strong>{emptyState.title}</strong>
            <p>{emptyState.summary}</p>
          </div>
        ) : null}
      </div>

      <footer className="cd-mc-witness__footer">
        <span>Operational chronicle — derived readback, not saved session history</span>
      </footer>
      </div>
    </aside>
  )
}
